enum RoleEnum {
    Borrower = 'BORROWER',
    Broker = 'BROKER',
    Investor = 'INVESTOR',
}

export default RoleEnum;
